import _ from 'lodash';
import { i18n } from 'invision-core';
import CustomerCareKeys from '../../../../locales/keys';
import { BulkChargeTypes } from '../../newConnectWizard/new.connect.wizard.constants';
export var briNameAppend = function briNameAppend() {
  var invertedChargeTypes = _.invert(BulkChargeTypes);
  return function (briName, bulkChargeTypeCode) {
    var translationKey = CustomerCareKeys.DECISIONS.BULK_CHARGE_TYPE[invertedChargeTypes[bulkChargeTypeCode]];
    if (briName && translationKey) {
      return "".concat(briName, " (").concat(i18n.translate(translationKey), ")");
    }
    return briName;
  };
};